import { pick } from 'lodash';

export const APPOINTMENT_STATUS = {
  ATTENDED: 'attended',
  NOT_ATTENDED: 'not_attended',
  CANCELLED: 'cancelled',
  BOOKED: 'booked',
  DRAFTED: 'drafted',
};

export const APPOINTMENT_ATTENDANCE_STATUS = pick(APPOINTMENT_STATUS, ['ATTENDED', 'NOT_ATTENDED']);

export const APPOINTMENT_OUTCOME_TYPE = {
  SERVICE_PROVIDED: 'service_provided',
  PRESCRIPTION: 'prescription',
  ADVICE: 'advice',
  REFER_TO_GP: 'refer_to_gp',
};

export const APPOINTMENT_ORDER_FULFILMENT_OPTION = {
  DELIVERY: 'delivery',
  COLLECTION: 'collection',
  COLLECTION_POINT: 'collection_point',
};

export type AppointmentPharmacy = {
  _id: string;
  delivery_options: {
    collection: {
      repeat: boolean;
      otc: boolean;
    };
    collection_point: {
      repeat: boolean;
      otc: boolean;
    };
    local_delivery: {
      repeat: boolean;
      otc: boolean;
    };
    postal_delivery: {
      repeat: boolean;
      otc: boolean;
    };
  };
  chain: {
    _id: string;
    name: string;
    payment: {
      stripe_connect_id: string;
    };
  };
};
